<table>
  <tr>
    @if (showUseDate) {
      <td class="align-middle">
        <dx-check-box [(value)]="useDate" text="Use Date Range" [disabled]="disabled"></dx-check-box>
      </td>
    }
    @if (!showUseDate) {
      <td class="align-middle">
        Date:
      </td>
    }
    <td class="align-middle">
      <dx-date-box
        [min]="date_min"
        [(value)]="startDate"
        valueChangeEvent="keyup blur change focusout"
        (onValueChanged)="onDateChange($event)"
        width="125px"
        [disabled]="!useDate || disabled"
        >
        <dx-validator [validationGroup]="validationGroup">
          <dxi-validation-rule type="required" message="Start date is required"></dxi-validation-rule>
        </dx-validator>
      </dx-date-box>
    </td>
    <td class="align-middle">
      <div style="padding-left: 5px;">to</div>
    </td>
    <td class="align-middle">
      <dx-date-box
        [min]="date_min"
        [(value)]="stopDate"
        valueChangeEvent="keyup blur change focusout"
        (onValueChanged)="onDateChange($event)"
        width="125px"
        [disabled]="!useDate || disabled"
        >
        <dx-validator [validationGroup]="validationGroup">
          <dxi-validation-rule type="required" message="Ending date is required"></dxi-validation-rule>
        </dx-validator>
      </dx-date-box>
    </td>
    <td style="padding-left: 10px;">
      <dx-select-box
        #dateselect
        [dataSource]="quickDateList"
        [(value)]="QuickDateValue"
        displayExpr="name"
        valueExpr="value"
        (onSelectionChanged)="onQuickDateChange($event)"
        placeholder="Quick Date"
        width="200px"
        [disabled]="disableDropDown"
      ></dx-select-box>
    </td>
  </tr>
</table>
